import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button,  ThemeProviderV2} from '@blueprint/ui';

import { Loader } from "../../../common/components/core";
import {
    useAuthErrorHandlerCreator,
    useModalWithData,
} from "../../../common/hooks";

import { parseRoleToText } from "../../../utils/role";
import { UserRole } from "../../../types/userCurrent";

type UpdateUserHandler = {
    isSubmitting: boolean;
    handler: (
        updateRole: UserRole,
        prevRole: string,
        confirm: () => void,
        cancel: () => void,
    ) => void;
};

const useUpdateUserHandler = (): UpdateUserHandler => {
    const [isSubmitting, setSubmitting] = useState(false);
    const onAuthError = useAuthErrorHandlerCreator();

    const [show, hide] = useModalWithData<{
        updateRole: UserRole;
        prevRole: string;
        confirm: () => void;
        cancel: () => void;
    }>(
        (data) => () => {
            return (
                <ThemeProviderV2>
                <Modal show onHide={hide} backdrop="static" centered>
                    <Loader overlay isLoading={isSubmitting}>
                        <Modal.Header>
                            <h2 className="mb-0">
                                User Information Change
                            </h2>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                Are you sure you want to change the selected
                                user's role type from "
                                <span>
                                    {data?.prevRole &&
                                        parseRoleToText(data.prevRole)}
                                </span>
                                " to “
                                <span>
                                    {data?.updateRole &&
                                        parseRoleToText(data.updateRole)}
                                </span>
                                " ?
                            </div>
                            <div className="mt-5">
                                <div className="text-primary">IMPORTANT:</div>{" "}
                                <p className="fs-8">
                                    Please note that by changing the user's
                                    Profile Type/Profile Name/Role Type may
                                    result in the change in their access for
                                    certain functions and information.
                                </p>
                            </div>
                        </Modal.Body>

                        <Modal.Footer className="d-flex justify-content-between px-3">
                            <Button
                                variant="light.tertiary"
                                onClick={() => {
                                    data && data.cancel();
                                    hide();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="light.primary"
                                onClick={() => {
                                    setSubmitting(true);
                                    data && data.confirm();
                                    setSubmitting(false);
                                    hide();
                                }}
                            >
                                Confirm
                            </Button>
                        </Modal.Footer>
                    </Loader>
                </Modal>
                </ThemeProviderV2>
            );
        },
        [onAuthError],
    );

    return {
        isSubmitting,
        handler: (updateRole, prevRole, confirm, cancel) => {
            show({ updateRole, prevRole, confirm, cancel });
        },
    };
};

export default useUpdateUserHandler;
